import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const DesignLazy = loadable(() => import(/* webpackChunkName: "PagesLight" */ './DesignDefault'));

export const DesignAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <DesignLazy />
    </DelayedSuspense>
);
